// @ts-ignore: autogenerated import
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ModuleType = 'AUDIO' | 'EMBED' | 'GALLERY' | 'IMAGE' | 'LIVESTREAM' | 'TEXT' | 'VIDEO' | 'VIDEO360';

export type SearchQueryVariables = Exact<{
	searchTerm: string;
	count: number;
	cursor?: string | null | undefined;
}>;

export type SearchQuery = {
	searchResultArticles: {
		__typename: 'ArticlesConnection';
		totalCount: number;
		pageInfo: { __typename: 'PageInfo'; hasNextPage: boolean; cursor: string | null };
		edges: Array<{
			__typename: 'ArticlesEdge';
			node: {
				__typename: 'Article';
				modulesTypes: Array<ModuleType | null>;
				path: string;
				publicationDate: string | null;
				breakingnewsEnd: string | null;
				rowId: string;
				teaserText: string | null;
				title: string;
				image: {
					__typename: 'ModuleImage';
					altText: string | null;
					copyright: string | null;
					title: string | null;
					url: string | null;
				} | null;
			} | null;
		}>;
	} | null;
};

export const SearchDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'Search' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
					type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
					type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cursor' } },
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						alias: { kind: 'Name', value: 'searchResultArticles' },
						name: { kind: 'Name', value: 'filterArticles' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'searchPlain' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
							},
							{ kind: 'Argument', name: { kind: 'Name', value: 'sortBy' }, value: { kind: 'EnumValue', value: 'PUBLICATION_DATE_DESC' } },
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SearchResults' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'pageInfo' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', alias: { kind: 'Name', value: 'cursor' }, name: { kind: 'Name', value: 'endCursor' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
										],
									},
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ImageModule' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModuleImage' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'altText' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ArticleItemResultsItem' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'modulesTypes' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'path' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'breakingnewsEnd' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'teaserText' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'image' },
						selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageModule' } }] },
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SearchResults' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticlesConnection' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'edges' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'node' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleItemResultsItem' } }],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<SearchQuery, SearchQueryVariables>;
